import type { MemberElectionApplicationNode } from "../types";

export function memberElectionClassification(
  application: Pick<MemberElectionApplicationNode, "electionMemberClassification">
): string | null {
  const name = application.electionMemberClassification?.trim();
  if (!name || !/^A-/.test(name)) {
    return null;
  }

  return name;
}

export function selectedMemberElectionsClassState(
  applications: Pick<MemberElectionApplicationNode, "id" | "electionMemberClassification">[],
  selectedIds: string[]
): { missingClassCount: number; cannotFinalize: boolean } {
  if (selectedIds.length === 0) {
    return { missingClassCount: 0, cannotFinalize: false };
  }

  const selectedOnPage = applications.filter((application) => selectedIds.includes(application.id));
  const missingClassCount = selectedOnPage.filter((application) => !memberElectionClassification(application)).length;
  const allSelectedVisible = selectedOnPage.length === selectedIds.length;

  return {
    missingClassCount,
    cannotFinalize: allSelectedVisible && missingClassCount === selectedIds.length
  };
}
